import React, { useEffect, useRef, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import ProposedAssets from "../../components/TrancheBotV2/ProposedAssets";
import {
  getTrancheById,
  isMatchedCalculationOpportunity,
} from "../../service/api";
// import { isMatchedCalculationOpportunity } from "../../service/trancheBot.api";

const POLLING_INTERVAL = 15000; // 15s
const POLLING_TIMEOUT = 15 * 60 * 1000; // 15min

const ProposedAssetsPage = () => {
  const location = useLocation();
  const [pollingData, setPollingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const pollRef = useRef(null);
  const history = useHistory();

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id") || "";

  const fetchTrancheById = async () => {
    try {
      const res = await getTrancheById(id);
      if (!res?.data) throw new Error("Tranche not found");

      setPollingData({ data: { results: [res.data] } });
    } catch (err) {
      console.log("fetchTrancheById", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) return;
    const fetchInitialData = async () => {
      try {
        const res = await isMatchedCalculationOpportunity();
        if (res?.data?.data) {
          setPollingData(res.data);
          // Adjust based on how selectedOpportunities are obtained
        }
      } catch (err) {
        console.error("Error fetching initial data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (
      location.state?.pollingData?.data?.results?.length >= 0 &&
      location.state?.selectedOpportunities?.length > 0
    ) {
      setPollingData(location.state.pollingData);
      setLoading(false);
    } else {
      fetchInitialData();
    }
  }, [location.state]);

  // 🔁 Poll for updates if jobCount > 0
  useEffect(() => {
    if (!pollingData?.data || id) return;
    if (pollingData?.data?.jobCount === 0) return; // ✅ stop polling if jobCount 0

    const pollingStart = Date.now();

    pollRef.current = setInterval(async () => {
      if (Date.now() - pollingStart > POLLING_TIMEOUT) {
        clearInterval(pollRef.current);
        pollRef.current = null;
        return;
      }

      try {
        const res = await isMatchedCalculationOpportunity();
        const newResults = res?.data?.data?.results ?? [];
        const jobCount = res?.data?.data?.jobCount ?? 0;

        setPollingData((prev) => {
          const prevResults = prev?.data?.results ?? [];
          const mergedResults = [
            ...prevResults,
            ...newResults.filter(
              (r) => !prevResults.some((pr) => pr._id === r._id)
            ),
          ];
          return {
            data: {
              ...res.data.data,
              results: mergedResults,
              jobCount,
            },
          };
        });

        if (jobCount === 0) {
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
      } catch (err) {
        console.error("Polling error:", err);
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    }, POLLING_INTERVAL);

    return () => {
      clearInterval(pollRef.current);
      pollRef.current = null;
    };
  }, [pollingData]);

  useEffect(() => {
    id && fetchTrancheById();
  }, [id]);

  if (loading) {
    return (
      <div className="mx-3 d-flex justify-content-center align-items-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!pollingData) {
    return (
      <div className="w-[100vw] h-[100vh] d-flex justify-content-center align-items-center">
        <Alert variant="warning">
          No asset data found. Redirecting to the opportunities page...
        </Alert>
      </div>
    );
  }

  if (pollingData?.data?.results.length === 0) {
    history.push("/tranche-bot-v2");
  }

  return (
    <div className="mx-3">
      <ProposedAssets pollingData={pollingData} />
    </div>
  );
};

export default ProposedAssetsPage;
